import AttendeeType from 'owa-service/lib/contract/AttendeeType';

export default function (
    currentAttendees: AttendeeType[],
    newAttendees: AttendeeType[]
): AttendeeType[] {
    let mergedAttendees: AttendeeType[] = [];

    for (const newAttendee of newAttendees) {
        const newAttendeeSMTP = getSMTPFromAttendee(newAttendee);

        const duplicateAttendees: AttendeeType[] = mergedAttendees.filter(
            attendee => newAttendeeSMTP === getSMTPFromAttendee(attendee)
        );
        // Don't allow duplicate attendees
        if (duplicateAttendees.length === 0) {
            const existingAttendees: AttendeeType[] = currentAttendees.filter(
                attendee => newAttendeeSMTP === getSMTPFromAttendee(attendee)
            );
            // If we have an entry of current Attendees, return that to preserve any extra data we may have.
            // If we don't simply return the new Attendee.
            const attendeeToBeAdded =
                existingAttendees.length >= 1 ? existingAttendees[0] : newAttendee;

            mergedAttendees.push(attendeeToBeAdded);
        }
    }

    return mergedAttendees;
}

function getSMTPFromAttendee(attendee: AttendeeType) {
    return attendee?.Mailbox?.EmailAddress && attendee.Mailbox.EmailAddress.toLowerCase();
}
